import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { IMeasurementType } from "../../screens/measurement-type/MeasurementTypeListController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

interface IMeasurementFieldPayload
  extends Omit<
    IMeasurementType,
    "id" | "created_by" | "created_date" | "modified_by" | "modified_date"
  > {}

export const GET_ALL_MEASUREMENT_TYPE = (
  pagination: IPagination,
  search: string,
  advanceSearch: string
) => {
  const searchGender =
    advanceSearch.length > 0 ? `&gender=${advanceSearch}` : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_measurement_type.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchGender}`,
    API_ENDPOINTS.get_all_measurement_type.method
  );
};

export const DELETE_MEASUREMENT_TYPE = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_measurement_type.url + `/${id}`,
    API_ENDPOINTS.delete_measurement_type.method
  );
};

export const GET_MEASUREMENT_TYPE_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_measurement_type.url + `/${id}`,
    API_ENDPOINTS.get_all_measurement_type.method
  );
};

export const CREATE_MEASUREMENT_TYPE = (payload: IMeasurementFieldPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_measurement_type.url,
    API_ENDPOINTS.create_measurement_type.method,
    payload
  );
};

export const UPDATE_MEASUREMENT_TYPE = (
  payload: IMeasurementFieldPayload,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_measurement_type.url + `/${id}`,
    API_ENDPOINTS.update_measurement_type.method,
    payload
  );
};

export const ACTIVE_INACTIVE_MEASUREMENT_TYPE = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_measurement_type.url + `/${id}`,
    API_ENDPOINTS.active_inactive_measurement_type.method,
    activeInactiveValue
  );
};

export const MEASUREMENT_FIELD_DDL = (payload: { required_ids: string[] }) => {
  return serviceMaker(
    API_ENDPOINTS.measurement_field_ddl.url,
    API_ENDPOINTS.measurement_field_ddl.method,
    payload
  );
};
